var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeer = function SvgBeer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.4V6.9c0-.9.9-1.4 1.6-1 .4-1 1.6-1 2 0 .5-.8 1.5-.8 1.9.1.5-1 1.7-.9 2 .1C14 5.6 15 6 15 7v1.4ZM6 8.4h9V18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zM15 10h1.6a3 3 0 0 1 0 6H15v-2h1.6a1 1 0 0 0 0-2H15z"
  })));
};
export default SvgBeer;